import {
  Box,
  Button,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";

import EmptyImage from "../assets/empty.png";

const EmptyState = ({
  title = "No Data Available",
  message = "There is nothing to display at the moment.",
  imageSize = "180px",
  titleFontSize = "1xl",
  messageFontSize = "md",
  titleColor = "#071D54",
  messageColor = "gray.500",
  buttonLabel,
  buttonIcon,
  onButtonClick,
  maxW = "450px",
  spacing = 5,
  py = 10,
}) => {
  return (
    <Box
      w="100%"
      py={py}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <VStack
        gap={spacing}
        maxW={maxW}
        textAlign="center"
      >
        <Image
          src={EmptyImage}
          alt="Empty State"
          boxSize={imageSize}
          objectFit="contain"
          draggable={false}
        />

        <Text
          fontSize={titleFontSize}
          fontWeight="700"
          color={titleColor}
        >
          {title}
        </Text>

        {message && (
          <Text
            fontSize={messageFontSize}
            color={messageColor}
            lineHeight="1.7"
            p={5}
          >
            {message}
          </Text>
        )}

        {buttonLabel && (
          <Button
            colorScheme="blue"
            size="lg"
            borderRadius="xl"
            leftIcon={buttonIcon}
            onClick={onButtonClick}
          >
            {buttonLabel}
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default EmptyState;